var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "notification-item",
      style: !!_vm.item.hasLink ? "cursor: pointer" : "",
      on: {
        click: function click($event) {
          !!_vm.item.hasLink ? _vm.emitId("visit", _vm.item) : ""
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "notification-body"
        },
        [
          _c(
            "div",
            {
              staticClass: "notification-title"
            },
            [_vm._v(" " + _vm._s(_vm.item.title) + " ")]
          ),
          _c(
            "div",
            {
              staticClass: "notification-description"
            },
            [_c("p", [_vm._v(_vm._s(_vm.item.description))])]
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "notification-actions text-right"
        },
        [
          _c(
            "v-btn",
            {
              attrs: {
                text: "",
                color: "primary"
              },
              on: {
                click: function click($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k(
                      $event.keyCode,
                      "s",
                      undefined,
                      $event.key,
                      undefined
                    )
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  return _vm.emitId("dismiss", _vm.item)
                }
              }
            },
            [_vm._v(" Dismiss ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }